import funnels from './funnels';
import pageNames from './pageNames';
export default function getPathTemplate(_ref) {
  let {
    pageName,
    brand,
    basePath,
    useUpdatedVdpPath
  } = _ref;
  let pathname;

  // allow for optional basePath
  const getBasePath = funnelBasePath => basePath ? `/${funnelBasePath}` : '';
  const findDealer = brand === 'kbb' ? funnels.FIND_DEALER_KBB : funnels.FIND_DEALER;
  switch (pageName) {
    case pageNames.DEALER_SEARCH:
      {
        pathname = `${getBasePath(findDealer)}/:seoListingType?/:seoMakeCode?/:seoLocation?`;
        break;
      }
    case pageNames.DEALER_DETAILS:
      {
        pathname = `${getBasePath(findDealer)}/:seoLocation?/:seoVirtual?/:dealerId/:seoDealerName?`;
        break;
      }
    case pageNames.SEARCH_FORM:
      {
        pathname = `${getBasePath(funnels.FIND_CAR)}/advanced-search`;
        break;
      }
    case pageNames.SEARCH_RESULTS:
      {
        const pathParams = ':seoExperience?/' + ':seoListingType?/' + ':seoSellerType?/' + ':seoVehicleStyleCode?/' + ':seoDriveGroup?/' + ':seoEngineCode?/' + ':seoFuelTypeGroup?/' + ':seoPrice?/' + ':seoFeatureCode?/' + ':seoMoneyBackGuarantee?/' + ':seoExtColorSimple?/' + ':seoCommercialVehicles?/' + ':seoYear?/' + ':seoMakeCode?/' + ':seoSeriesCode?/' + ':seoModelCode?/' + ':seoTrimCode?/' + ':seoLocation?/';
        pathname = `${getBasePath(funnels.FIND_CAR)}/${pathParams}`;
        break;
      }
    case pageNames.VEHICLE_DETAILS:
      {
        pathname = `${getBasePath(funnels.FIND_CAR)}/vehicledetails.xhtml`;
        if (useUpdatedVdpPath) {
          // allow for temp backwards compatability
          pathname = `${getBasePath(funnels.FIND_CAR)}/vehicle/[:seoListingId?||:seoVin?]`;
        }
        break;
      }
    case pageNames.BUILD_PRICE:
      {
        pathname = `${getBasePath(funnels.FIND_CAR)}/build-and-price`;
        break;
      }
    case pageNames.FORD_LANDING:
      {
        pathname = `${getBasePath(funnels.FIND_CAR)}`;
        break;
      }
    case pageNames.MARKETPLACE_LANDING:
      {
        pathname = `${getBasePath(funnels.MARKETPLACE)}`;
        break;
      }
    case pageNames.MARKETPLACE_SEARCH:
      {
        // TODO: SEO paths
        pathname = `${getBasePath(funnels.MARKETPLACE)}/listings`;
        break;
      }
    case pageNames.MARKETPLACE_DETAILS:
      {
        pathname = `${getBasePath(funnels.MARKETPLACE)}/listings/:listingId`;
        break;
      }
    case pageNames.FYC_SITEMAP:
      {
        pathname = `${getBasePath(funnels.FIND_CAR)}/sitemap/:sitemapPageId`;
        break;
      }
    default:
  }
  return pathname;
}